module.exports = __webpack_public_path__ + "img/home-index-menu5.735f723e.png";